export default __webpack_public_path__ + "static/media/mayc.88fda50c.png";